import { Controller } from "@hotwired/stimulus"

// A small touch back from the phone when something is done - a like, a keep,
// a post shared. In the apps the tap reaches native code over the bridge
// (see native.js); in a browser that can, the phone buzzes very briefly; on a
// desk nothing happens at all.
export default class extends Controller {
  static values = { style: { type: String, default: "light" } }

  // For a form: only once the server has taken it.
  submitted(event) {
    if (event.detail?.success) this.tap()
  }

  tap() {
    if (window.SubstanceNative?.available) {
      window.SubstanceNative.haptic(this.styleValue)
    } else if (navigator.vibrate) {
      navigator.vibrate(this.styleValue === "success" ? [10, 30, 10] : 8)
    }
  }
}
